import { render, staticRenderFns } from "./SwitchAdminForLbSubscription.vue?vue&type=template&id=394c155e&scoped=true&"
import script from "./SwitchAdminForLbSubscription.vue?vue&type=script&lang=js&"
export * from "./SwitchAdminForLbSubscription.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAdminForLbSubscription.vue?vue&type=style&index=0&id=394c155e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394c155e",
  null
  
)

export default component.exports